import { Platform, type TextStyle } from 'react-native';

/** 롤링 digit 셀 높이 = lineHeight (카운트다운 스트립·넛지 가격칩 공용) */
export const DIGIT_HEIGHT = 16;

/** 카운트다운/넛지 롤링 텍스트 공용 스타일. fontSize만 다름(타이머 12 / 가격칩 13) */
export const promotionRollingTextStyle = (
  fontSize: number,
  color: string,
): TextStyle => ({
  fontFamily: Platform.select({
    ios: 'Pretendard-SemiBold',
    android: 'pretendard_semi_bold',
  }),
  fontSize,
  lineHeight: DIGIT_HEIGHT,
  letterSpacing: -0.2,
  color,
});
